/**
 * Certificate templates (MVP Spec §9). `bodyHtml` is a short admin-authored
 * descriptive line rendered as plain text onto a fixed WithAWill-branded PDF
 * layout — not interpreted as HTML->PDF markup, which is out of scope for a
 * Phase-1 pilot of 8 learners. See apps/api/src/lib/certificate-pdf.ts.
 */
import { z } from "zod";
export const certificateSignatorySchema = z.object({
    name: z.string().trim().min(1).max(150),
    title: z.string().trim().min(1).max(150),
    // Set via the separate signature-image upload endpoint, not directly by
    // this schema's caller — round-tripped through save() so an existing
    // upload survives an unrelated template edit.
    imageRef: z.string().nullable().optional(),
});
export const createCertificateTemplateSchema = z.object({
    title: z.string().trim().min(1).max(200),
    // null = a global fallback template usable by any programme without one of
    // its own.
    programmeId: z.string().min(1).nullable().default(null),
    bodyHtml: z.string().trim().min(1).max(4000),
    // Matches the certificate layout's fixed 3 signature-line slots.
    signatories: z.array(certificateSignatorySchema).min(1).max(3),
    showScore: z.boolean().default(true),
});
export const updateCertificateTemplateSchema = z.object({
    title: z.string().trim().min(1).max(200).optional(),
    bodyHtml: z.string().trim().min(1).max(4000).optional(),
    signatories: z.array(certificateSignatorySchema).min(1).max(3).optional(),
    showScore: z.boolean().optional(),
    active: z.boolean().optional(),
});
//# sourceMappingURL=certificate.js.map